import { render } from "./UserPassword.vue?vue&type=template&id=1e1f18e2&scoped=true"
import script from "./UserPassword.vue?vue&type=script&lang=js"
export * from "./UserPassword.vue?vue&type=script&lang=js"

import "./UserPassword.vue?vue&type=style&index=0&id=1e1f18e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1f18e2"],['__file',"resources/js/components/User/UserPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e1f18e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e1f18e2', __exports__)) {
    api.reload('1e1f18e2', __exports__)
  }
  
  module.hot.accept("./UserPassword.vue?vue&type=template&id=1e1f18e2&scoped=true", () => {
    api.rerender('1e1f18e2', render)
  })

}


export default __exports__